// extracted by mini-css-extract-plugin
export default {"breakpointPostContentAreaMin":"746px","breakpointPostContentAreaSmall":"900px","app":"Vg4Hp","postPageApp":"O70vf","fixed":"wMlhS","scrollable":"lCGfb","backgroundOverlay":"gmwDC"};